export default __webpack_public_path__ + "3a72b6366cbf9322f75a4dc043bfa6eb.jpg";